module.exports = __webpack_public_path__ + "static/media/question-circle-blue.9f5d31b4.svg";